module.exports = __webpack_public_path__ + "img/teamImg6.637f0faa.jpg";